<template>
  <div class="wecom-kf-page">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="质检概览" name="insight">
        <wecom-kf-insight @open-sessions="openSessions" />
      </el-tab-pane>
      <el-tab-pane label="会话记录" name="session" lazy>
        <wecom-kf-session :preset="sessionPreset" />
      </el-tab-pane>
      <el-tab-pane label="规则配置" name="rule" lazy>
        <wecom-kf-rule />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import WecomKfInsight from "./Insight/index.vue";
import WecomKfSession from "./Session/index.vue";
import WecomKfRule from "./Rule/index.vue";

export default {
  components: {
    WecomKfInsight,
    WecomKfSession,
    WecomKfRule
  },
  data() {
    return {
      activeTab: "insight",
      sessionPreset: null
    };
  },
  methods: {
    openSessions(preset) {
      this.sessionPreset = preset;
      this.activeTab = "session";
    }
  }
};
</script>
<style scoped lang="less">
.wecom-kf-page {
  padding: 0 20px 0 10px;
}
</style>